import { MarketingPageHeader } from '../Header/MarketingPageHeader';
import { Footer } from '../Landing/LandingFooter';
import { LandingHelp } from '../Landing/LandingHelp';
import { DEXAggregatorSection } from './DEXAggregatorSection';
import { InstantGasFreeSwapsSection } from './InstantGasFreeSwapsSection';
import { MatchaAutoBenefitsSection } from './MatchaAutoBenefitsSection';
import { MatchaAutoHero } from './MatchaAutoHero';
import { MatchaAutoSwitchSection } from './MatchaAutoSwitchSection';
import { MatchaAutoUsersSection } from './MatchaAutoUsersSection';

export function MatchaAuto() {
  return (
    <div
      className="overflow-auto desktop:bg-[100%_930px] desktop:bg-center-top"
      style={{
        background: 'url(/images/matcha-auto/matcha-auto-background.svg) no-repeat left top',
      }}
    >
      <MarketingPageHeader />
      <MatchaAutoHero />
      <main
        className="ml-[18px] mr-[18px] tablet:ml-11 tablet:mr-11 desktop:ml-auto desktop:mr-auto desktop:p-4 py-0"
        data-lock-theme="true"
      >
        <InstantGasFreeSwapsSection />
        <MatchaAutoBenefitsSection />
        <MatchaAutoUsersSection />
        <MatchaAutoSwitchSection />
        <DEXAggregatorSection />
        <LandingHelp />
      </main>
      <Footer />
    </div>
  );
}
